module.exports = __webpack_public_path__ + "img/p3-left.d0836f64.svg";